// utils/soloLectura.js — F7. La tienda activa puede estar conectada en modo SOLO LECTURA
// (plataforma Shopify v1): el backend lo expone en `config.tienda.soloLectura` y corta toda
// escritura con 409 `solo_lectura`. El frontend NUNCA muestra un botón gris mudo: los que
// escriben se ven DESHABILITADOS con este texto, y hay un aviso global ante cualquier 409.
export const MENSAJE_SOLO_LECTURA = 'Esta tienda está conectada en modo solo lectura: los cambios se hacen en Shopify.';

// Props para un <Button>/botón que escribe: deshabilitado + tooltip claro cuando la tienda es
// read-only; nada cuando escribe (SH). Se hace spread: <Button {...propsSoloLectura(solo)} …>.
export function propsSoloLectura(soloLectura) {
  return soloLectura ? { disabled: true, title: MENSAJE_SOLO_LECTURA } : {};
}

// ¿La config dice que la tienda activa es de solo lectura?
export function esSoloLectura(config) {
  return !!(config && config.tienda && config.tienda.soloLectura);
}

// F8.4: la tienda Shopify se DESCONECTÓ (la app se desinstaló → el token quedó revocado). Los
// datos del espejo siguen visibles, pero no se actualizan hasta reconectar.
export const MENSAJE_DESCONECTADA = 'Tu tienda de Shopify se desconectó (la app fue desinstalada). Los datos siguen visibles pero ya no se actualizan. Para reconectarla, reinstalá la app de Netto desde tu panel de Shopify.';

export function esDesconectada(config) {
  return !!(config && config.tienda && config.tienda.desconectada);
}

// F9 — ciclo comercial.
// Suspendida: pausa deliberada (p. ej. falta de pago). El sync se detiene atrás; el panel avisa.
export const MENSAJE_SUSPENDIDA = 'Tu cuenta está suspendida. Los datos ya no se actualizan. Contacta a Netto para reactivarla.';

export function esSuspendida(config) {
  return !!(config && config.tienda && config.tienda.estado === 'suspendida');
}

// Aviso de fin de prueba: devuelve el objeto `prueba` del backend si hay que avisar (<= N días o
// vencida), o null. El backend ya decidió `avisar` con PRUEBA_AVISO_DIAS; el front sólo lo pinta.
export function avisoFinPrueba(config) {
  const p = config && config.tienda && config.tienda.prueba;
  return p && p.avisar ? p : null;
}

// F9 — superadmin de plataforma viendo una tienda que no es la suya (soporte). La franja lo
// recuerda MIENTRAS dure (decisión 2). El backend decide `soporte.activo`.
export function infoSoporte(config) {
  const s = config && config.tienda && config.tienda.soporte;
  return s && s.activo ? s : null;
}

export function mensajeSoporte(soporte) {
  if (!soporte) return '';
  return `Estás viendo la tienda ${soporte.nombre || soporte.tiendaId} como soporte (Netto).`;
}

// Mensaje del banner de prueba, según días restantes (vencida vs faltan N).
export function mensajeFinPrueba(prueba) {
  if (!prueba) return '';
  if (prueba.vencida) return 'Tu mes de prueba terminó. Contacta a Netto para continuar.';
  const d = prueba.dias_restantes;
  if (d <= 0) return 'Tu mes de prueba termina hoy. Contacta a Netto para continuar.';
  return `Tu mes de prueba termina en ${d} ${d === 1 ? 'día' : 'días'}. Contacta a Netto para continuar.`;
}
